<script src="./Home.js" />
<style src="./Home.scss" lang="scss"></style>
<i18n src="./Home.txt" lang="yaml"></i18n>

<template>
  <div>
    <transition name="slide-fade" appear>
      <vueper-slides autoplay class="slider-area" :arrows="false" :pause-on-hover="false" :fade="true"
        :bulletsOutside="true">
        <vueper-slide v-for="(slide, i) in slides" :key="i">
          <template v-slot:content="">
            <div class="single-slider bg-img align-items-center custom-d-flex"
              :style="`background-image:url(${require(`presentation/assets/img/${slide.content.bgImage}`)});`">
              <div class="container">
                <div class="row height-100-percent align-items-center">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="slider-content-8 slider-animated-1 text-center">


                      <div class="slider-btn-1" v-if="slide.content.bttnTex">
                        <router-link :to="{ name: 'home' }" class="animated">
                          {{
                              slide.content.bttnTex
                          }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </vueper-slide>
      </vueper-slides>
    </transition>
  </div>
  <div class="banner-area pt-30">
    <div class="custom-container">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-xs-12" v-for="(currentItem, key) in componentList" :key="key">
          <div class="banner-wrap mb-30 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s"
            v-for="(item, itemInd) in currentItem.fields.box" :key="itemInd">
            <div class="banner-img banner-hover banner-zoom">
              <router-link :to="{ name: 'products', params: { categorySlug: 'men' } }">
                <img :src="item.fields.image.fields.file.url" alt="banner" />
                <div class="banner-content">
                  <h3>{{ item.fields.text }}</h3>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
